(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets/assets/javascripts/next/areas/play/containers/use-custom-events.js') >= 0) return;  svs.modules.push('/modules/tickets/assets/javascripts/next/areas/play/containers/use-custom-events.js');
"use strict";

const _React = React,
  useEffect = _React.useEffect;
const useCustomEvents = _ref => {
  let ticketInfo = _ref.ticketInfo,
    demo = _ref.isDemo,
    history = _ref.history,
    dispatch = _ref.dispatch,
    setIsGameLoaded = _ref.setIsGameLoaded,
    hasUnscratchedTicket = _ref.hasUnscratchedTicket;
  const logEvent = (eventName, detail) => {
    var _svs$tickets$logger;
    (_svs$tickets$logger = svs.tickets.logger) === null || _svs$tickets$logger === void 0 || _svs$tickets$logger.info("[next/play] custom event: ".concat(eventName), detail);
  };
  const handleBetDone = _ref2 => {
    let detail = _ref2.detail;
    logEvent('HAS_BET', detail);
    const data = detail.data,
      betAmount = detail.betAmount,
      serviceName = detail.serviceName;
    const ticketPrice = betAmount.value / 100;
    if (!demo) {
      var _svs$ticketgames$tick;
      dispatch({
        type: 'SET_BET_ID',
        payload: data.id
      });
      (_svs$ticketgames$tick = svs.ticketgames.ticketUtility.utils.tracking.gameSpecificTracking[ticketInfo.type]) === null || _svs$ticketgames$tick === void 0 || _svs$ticketgames$tick.bet();
      svs.ticketgames.ticketUtility.utils.tracking.sendAnalytics(data.id, serviceName, ticketPrice, ticketInfo, false);
    }
  };
  const onPlayAgain = () => {
    if (hasUnscratchedTicket) {
      svs.tickets.next.utils.utils.redirectToOngoing();
      return;
    }
    svs.ticketgames.ticketUtility.utils.tracking.trackChooseNewTicket(ticketInfo.type);
    history.push("/valja/".concat(ticketInfo.type));
  };
  useEffect(() => {
    const customEvents = [{
      eventName: 'HAS_BET',
      handler: handleBetDone
    }, {
      eventName: 'GAME_LOADING',
      handler: () => {
        logEvent('GAME_LOADING');
        svs.tickets.next.utils.utils.hideHeaders(true);
        svs.tickets.next.utils.utils.scrollTopContent();
      }
    }, {
      eventName: 'TAG',
      handler: _ref3 => {
        var _detail$viewInfo, _detail$viewInfo2;
        let detail = _ref3.detail;
        logEvent('TAG', detail);
        if ((detail === null || detail === void 0 ? void 0 : detail.eventType) === 'view' && (detail === null || detail === void 0 || (_detail$viewInfo = detail.viewInfo) === null || _detail$viewInfo === void 0 ? void 0 : _detail$viewInfo.name) === 'game' && (detail === null || detail === void 0 || (_detail$viewInfo2 = detail.viewInfo) === null || _detail$viewInfo2 === void 0 ? void 0 : _detail$viewInfo2.state) === 'didAppear') {
          logEvent('TAG.game.didAppear');
          setIsGameLoaded(true);
        }
      }
    }, {
      eventName: 'HAS_CLAIMED',
      handler: () => {
        logEvent('HAS_CLAIMED');
        svs.tickets.next.utils.utils.scrollTopContent();
        svs.tickets.next.utils.utils.showHeaders(true);
      }
    }, {
      eventName: 'REPLAY_FINISHED',
      handler: () => {
        logEvent('REPLAY_FINISHED');
        svs.tickets.next.utils.utils.scrollTopContent();
        svs.tickets.next.utils.utils.showHeaders(true);
      }
    }];
    customEvents.forEach(evt => addEventListener(evt.eventName, evt.handler));
    return () => {
      customEvents.forEach(evt => removeEventListener(evt.eventName, evt.handler));
    };
  }, []);
  return {
    onPlayAgain
  };
};
setGlobal('svs.tickets.next.areas.play.containers.useCustomEvents', useCustomEvents);

 })(window);